import type { SVGProps } from 'react'

interface SatelliteSyntheticIconProps extends SVGProps<SVGSVGElement> {}

export function SatelliteSyntheticIcon(props: SatelliteSyntheticIconProps) {
  return (
    <svg
      width={72}
      height={47}
      viewBox="0 0 72 47"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M35.808 24.353l.274-.16.224.128-.147.568.038 11.052-.166.396-.223-.128V24.353z"
        fill="currentColor"
      />
      <path
        d="M36.031 24.48l.275-.16v11.858l-.275.16V24.48z"
        fill="currentColor"
      />
      <path
        d="M36.663 34.957l-.466-.581-.543-.313-.466.045-.275.383v.626l.275.696.466.582.543.313.466-.038.275-.39v-.62l-.275-.703z"
        fill="currentColor"
      />
      <path
        d="M36.197 35.002l.467-.045.274.703.013 1.01-.703-1.189-.05-.479z"
        fill="currentColor"
      />
      <path
        d="M35.328 33.858l.869.518.466.581-.306.18-.818-.87-.21-.409zM34.185 33.5l-.044-.325-1.029.09-.14.082.287.237.926-.083zM36.21 38.97l.147-.084.594-.85-.275-.115-.466 1.048z"
        fill="currentColor"
      />
      <path
        d="M36.81 36.644l.14.025v1.367l-.146.084-.109-1.425.115-.051z"
        fill="currentColor"
      />
      <path
        d="M36.107 35.13l.25.006.594 1.533-.147.084-.684-1.534-.013-.09z"
        fill="currentColor"
      />
      <path
        d="M35.125 33.852l.204.006 1.029 1.278-.147.083-1.188-1.278.102-.089z"
        fill="currentColor"
      />
      <path
        d="M34 33.258l.14-.083 1.189.684-.147.083-.927-.083-.255-.6z"
        fill="currentColor"
      />
      <path
        d="M36.21 35.22l-1.029-1.278L34 33.258l-1.029.09-.594.843v1.373l.594 1.533L34 38.375l1.181.684 1.029-.09.594-.85v-1.367l-.594-1.533z"
        fill="currentColor"
      />
      <path
        d="M35.986 35.353l-.754-.939-.862-.498-.754.064-.434.62v1.002l.434 1.119.754.932.862.505.754-.07.435-.614v-1.003l-.435-1.118z"
        fill="currentColor"
      />
      <path
        d="M35.782 35.468l-.472-.581-.544-.313-.466.045-.275.383v.626l.275.696.466.588.544.313.472-.045.269-.383v-.626l-.269-.703z"
        fill="currentColor"
      />
      <path
        d="M35.169 35.609l-.262-.147-.185.102v.307l.185.313.262.153.185-.109v-.3l-.185-.32z"
        fill="currentColor"
      />
      <path
        d="M33.2 36.99v.082l.02.02 1.903-1.1v-.083L33.2 36.99z"
        fill="currentColor"
      />
      <path
        d="M33.187 36.9l1.885-1.074.05.083-1.903 1.099-.064-.083.032-.026z"
        fill="currentColor"
      />
      <path
        d="M35.002 35.782l-1.898 1.098.007.039.064.006 1.897-1.099-.07-.044z"
        fill="currentColor"
      />
      <path
        d="M33.175 36.925l-.07-.045-.051.032v.077l.05.09.071.038.045-.026v-.083l-.045-.083z"
        fill="currentColor"
      />
      <path
        d="M33.086 37.116l.006.25.058.057.147-.083v-.256l-.211.032z"
        fill="currentColor"
      />
      <path
        d="M33.034 36.816h.102l.16.268-.147.083-.21-.268.095-.083z"
        fill="currentColor"
      />
      <path
        d="M32.92 36.688l-.14.084.031.12.185.007.141-.083-.217-.128z"
        fill="currentColor"
      />
      <path
        d="M32.996 36.9l-.217-.128-.16.089v.256l.16.268.217.128.153-.09v-.255l-.153-.269zM6.095 12.323L.89 9.321 6.268 0l5.206 3.003-.894 1.84-3.686 6.24-.799 1.24z"
        fill="currentColor"
      />
      <path
        d="M6.3 12.444l-.204-.12 5.379-9.322.204.122-5.379 9.32z"
        fill="currentColor"
      />
      <path
        d="M11.474 15.434l-5.206-3.009 5.379-9.32 5.213 3.009-.895 1.833-3.686 6.242-.805 1.245z"
        fill="currentColor"
      />
      <path
        d="M11.679 15.55l-.204-.116 5.385-9.32.198.115-5.379 9.32z"
        fill="currentColor"
      />
      <path
        d="M16.86 18.539l-5.207-3.009 5.38-9.314 5.206 3.002-.895 1.84-3.686 6.242-.798 1.239z"
        fill="currentColor"
      />
      <path
        d="M17.057 18.654l-.198-.115 5.38-9.32.204.12-5.386 9.315z"
        fill="currentColor"
      />
      <path
        d="M22.239 21.644l-5.207-3.003 5.38-9.32 5.206 3.008-.895 1.834-3.68 6.241-.804 1.24z"
        fill="currentColor"
      />
      <path
        d="M22.443 21.765l-.205-.121 5.38-9.315.204.115-5.38 9.321z"
        fill="currentColor"
      />
      <path
        d="M27.624 24.755l-5.213-3.009 5.386-9.32 5.206 3.008-.894 1.84-3.686 6.242-.799 1.24z"
        fill="currentColor"
      />
      <path
        d="M27.822 24.87l-.198-.115 5.379-9.32.198.115-5.379 9.32z"
        fill="currentColor"
      />
      <path
        d="M31.572 21.452l-1.533-.888.543-.945 1.54.888-.147.53-.403.415z"
        fill="currentColor"
      />
      <path
        d="M32.12 20.508l-.546.946.205.118.547-.945-.205-.119zM43.914 26.742l-7.864 4.536v-6.644l7.864-4.542v6.65zM36.05 31.278l-7.858-4.536v-6.65l6.945 2.983.913 1.559v6.644z"
        fill="currentColor"
      />
      <path
        d="M36.05 24.634l-7.858-4.543 7.858-4.535 7.864 4.535-7.864 4.543zM28.505 22.666l1.833 1.06v-1.162l-1.833-1.054v1.156z"
        fill="currentColor"
      />
      <path
        d="M30.364 22.602l-.026-.038-1.833-1.054.115-.07 1.833 1.06-.09.102z"
        fill="currentColor"
      />
      <path
        d="M30.338 23.727l.115-.07V22.5l-.115.064v1.163zM28.505 24.493l1.833 1.06v-1.156l-1.833-1.06v1.156z"
        fill="currentColor"
      />
      <path
        d="M30.364 24.43l-.026-.033-1.833-1.06.115-.064 1.833 1.06-.09.096z"
        fill="currentColor"
      />
      <path
        d="M30.338 25.554l.115-.064v-1.156l-.115.063v1.157zM28.505 26.326l1.833 1.055v-1.157l-1.833-1.06v1.162z"
        fill="currentColor"
      />
      <path
        d="M30.364 26.262l-.026-.038-1.833-1.06.115-.064 1.833 1.06-.09.102z"
        fill="currentColor"
      />
      <path
        d="M30.338 27.38l.115-.063V26.16l-.115.064v1.157zM43.27 26.32l-6.223 3.59v-4.65l6.222-3.59v4.65z"
        fill="currentColor"
      />
      <path
        d="M36.964 25.381l.083-.121 6.222-3.59-.18-.103-6.215 3.59.09.224z"
        fill="currentColor"
      />
      <path
        d="M37.047 29.91l-.173-.102v-4.65l.172.102v4.65zM44.853 20.258l-8.803 5.078-.44-3.315 9.243-4.823v3.06z"
        fill="currentColor"
      />
      <path
        d="M36.05 25.336l-8.797-5.078v-3.06l7.768 3.334 1.029 1.744v3.06z"
        fill="currentColor"
      />
      <path
        d="M36.05 22.276l-8.797-5.078 8.797-5.086 8.803 5.086-8.803 5.078z"
        fill="currentColor"
      />
      <path
        d="M44.215 17.204l-8.165 4.715-1.245-6.868 9.41-3.986v6.139z"
        fill="currentColor"
      />
      <path
        d="M36.05 21.919l-8.157-4.715v-6.14l7.206 3.093.952 1.616v6.146z"
        fill="currentColor"
      />
      <path
        d="M36.05 15.773l-8.157-4.708L36.05 6.35l8.165 4.715-8.165 4.708zM40.34 25.254l-.548.945.204.119.549-.945-.205-.119z"
        fill="currentColor"
      />
      <path
        d="M40.331 25.246l-.546.946 1.737 1.003.547-.946-1.738-1.003z"
        fill="currentColor"
      />
      <path
        d="M44.113 34.274l-5.207-3.003 5.38-9.32 5.206 3.002-.895 1.84-3.686 6.241-.798 1.24z"
        fill="currentColor"
      />
      <path
        d="M49.497 24.958l-5.387 9.32.205.117 5.387-9.32-.205-.117z"
        fill="currentColor"
      />
      <path
        d="M49.492 37.385l-5.207-3.01 5.38-9.32 5.206 3.01-.895 1.833-3.68 6.241-.804 1.246z"
        fill="currentColor"
      />
      <path
        d="M54.89 28.078l-5.412 9.298.205.118 5.411-9.297-.204-.12z"
        fill="currentColor"
      />
      <path
        d="M54.871 40.49l-5.2-3.003 5.379-9.32 5.207 3.002-.895 1.84-3.686 6.241-.805 1.24z"
        fill="currentColor"
      />
      <path
        d="M60.244 31.168l-5.368 9.324.205.117 5.367-9.323-.204-.118z"
        fill="currentColor"
      />
      <path
        d="M60.256 43.594l-5.206-3.002 5.379-9.32 5.206 3.002-.894 1.84-3.68 6.241-.805 1.24z"
        fill="currentColor"
      />
      <path
        d="M65.639 34.28l-5.384 9.315.204.118 5.384-9.314-.204-.118z"
        fill="currentColor"
      />
      <path
        d="M65.635 46.706l-5.206-3.01 5.379-9.32 5.206 3.009-.888 1.833-3.686 6.242-.805 1.246z"
        fill="currentColor"
      />
      <path
        d="M71.02 37.398l-5.386 9.312.204.118 5.388-9.312-.205-.118z"
        fill="currentColor"
      />
    </svg>
  )
}
